import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './style.css';

const MobileNav = ({ navOpen, closeNav }) => {
  const { t } = useTranslation('common');

  return (
    <div className={`mobile__nav ${navOpen ? 'open' : ''}`}>
      <button onClick={closeNav} className="close-btn">✕</button>
      <ul className="mobile__nav-links">
        {[
          { to: '/',         key: 'home' },
          { to: '/prices',   key: 'prices' },
          { to: '/design',   key: 'design' },
          { to: '/projects', key: 'projects' },
          { to: '/gallery',  key: 'gallery' },
          { to: '/contacts', key: 'contacts' },
        ].map(({ to, key }) => (
          <li key={key}>
            <NavLink to={to} onClick={closeNav}>{t(`nav.${key}`)}</NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileNav;
